<!----
    Author: hjlee
    Description:
        비밀번호 찾기 모달
---->
<template>
  <b-modal
    v-if="configs"
    id="modal"
    ref="modalRef"
    :title="$t('forgot_password_modal.title.forgot_password')"
    :ok-title="$t('common.button.ok')"
    :cancel-title="$t('common.button.cancel')"
    :ok-disabled="!userId"
    @ok="confirm"
  >
    <div>
      <input-control
        v-model="userId"
        name="user_id"
        :no-title="true"
        :title="$t('column.nm.user_id')"
        class="user-id-input"
        :type="configs.account_system"
        :placeholder="$t('login_modal.placeholder.username')"
      />
    </div>
    <pig-tail-label v-if="!noPigTail && configs && configs.account_system" :message="$t('forgot_password_modal.alert.' + configs.account_system)" />
    <p v-if="notification" class="notification" v-html="notification" />
  </b-modal>
</template>

<script>
export default {
  props: {
    noPigTail: {
      type: Boolean,
      default: false
    },
    notification: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  data: function() {
    return {
      userId: '',
      userIdType: 'email',
      modalName: 'forgot_password_modal'
    }
  },
  watch: {
    userIdType(newVal, oldVal) {
      this.userId = ''
    }
  },
  methods: {
    getUserIdType: function() {
      if (this.configs) {
        if (this.configs.account_system === 'email') {
          return 'email'
        } else if (this.configs.account_system === 'tel') {
          return 'tel'
        }
      }
      return 'text'
    },
    onInputVueTelInput(p1, p2) {
      if (p2 && p2.number && p2.number.international) {
        this.userId = p2.number.international
      }
    },
    confirm: function(evt) {
      evt.preventDefault()
      this.$axios
        .$post('/auth/public/findPassword', {
          userId: this.userId,
          locale: localStorage.locale
        })
        .then(response => {
          if (response.resultCode === 'success') {
            this.$toast.info(this.$t(response.message, response.params))
            this.hideModal('modalRef')
          } else {
            this.$toast.error(this.$t(response.message, response.params))
          }
        })
        .catch(error => {
          if (
            error.response &&
            error.response.data &&
            error.response.data.resultCode &&
            error.response.data.resultCode === 'choose_name_for_same_id'
          ) {
            this.$eventHub.$emit('showChooseUserModal', {
              userId: this.userId,
              userPwd: '',
              action: 'findPassword'
            })
          }
        })
    }
  }
}
</script>

<style scoped>
.user-id-input {
  margin-bottom: 0;
}
.user-id-input input {
  border-radius: 4px;
}
</style>
